import { useTranslation } from 'next-i18next';
import { Button } from '@/ui_v3';
interface ProfileEditActionsProps {
  onSubmit: () => void;
  isPending: boolean;
  isDirty: boolean;
}
export const ProfileEditActions = ({
  onSubmit,
  isPending,
  isDirty
}: ProfileEditActionsProps) => {
  const {
    t
  } = useTranslation(['common']);
  const isSubmitDisabled = isPending || !isDirty;
  return <div className="flex w-full max-w-[640px]" data-sentry-component="ProfileEditActions" data-sentry-source-file="ProfileEditActions.tsx">
      <Button variant="contained" intent="strong" className="flex-1" onClick={onSubmit} disabled={isSubmitDisabled} data-sentry-element="Button" data-sentry-source-file="ProfileEditActions.tsx">
        {t('profileEdit.saveChanges')}
      </Button>
    </div>;
};